import iconsGif from "@/assets/spinner-iconos.gif";
import spinnerProgressGif from "@/assets/spinner-progreso.gif";
import useLoading from "../../../hooks/useLoading";
import { useModalStore } from "../../../stores/modalStore";
import {
  LoadingOverlay,
  LoadingText,
  MainSpinner,
  ProgressSpinner,
  SpinnerContainer,
} from "./LoadingSpinner.styles";

interface LoadingSpinnerProps {
  isLoading: boolean;
  message?: string;
  delay?: number;
}

const LoadingSpinner = ({
  isLoading,
  message = "Cargando...",
  delay = 1000,
}: LoadingSpinnerProps) => {
  const loadingWithDelay = useLoading(isLoading, delay);
  const shouldShowSpinner = delay === 0 ? isLoading : loadingWithDelay;
  const { isModalOpen } = useModalStore();

  return (
    <LoadingOverlay isVisible={shouldShowSpinner} $isModalOpen={isModalOpen}>
      <SpinnerContainer>
        <MainSpinner
          src={iconsGif}
          alt="Gif animado con imagenes sobre salud y biniestar"
        />
        <ProgressSpinner
          src={spinnerProgressGif}
          alt="barra de progreso de carga del loading"
        />
        {/* Texto opcional */}
        <LoadingText>{message}</LoadingText>
      </SpinnerContainer>
    </LoadingOverlay>
  );
};

export default LoadingSpinner;
